<template>
  <template v-if="[403, 404, 500].indexOf(errorStore.status_code) >= 0">
    <http-status :status-code="errorStore.status_code" :detail="errorStore.detail" :endpoint="errorStore.endpoint" />
  </template>
  <FullscreenLoading v-else :open="configStore.loading">
    <router-view />
  </FullscreenLoading>
</template>

<script lang="ts">
import { defineComponent, watchEffect } from "vue";
import { defineRule } from 'vee-validate';
import { useAccountStore, useConfigStore, useErrorStore } from "./stores";
import FullscreenLoading from "@/components/FullscreenLoading.vue";
import HttpStatus from "@/components/HttpStatus.vue";
import { validator } from '@/utils';

defineRule('required', validator.required);
defineRule('email', validator.email);
defineRule('minLength', validator.minLength);
defineRule('maxLength', validator.maxLength);
defineRule('passwordConfirm', validator.passwordConfirm);

export default defineComponent({
  name: "App",
  components: { FullscreenLoading, HttpStatus },
  mounted() {
    document.body.classList.add("bg-body-secondary");
  },
  setup() {
    const configStore = useConfigStore();
    const errorStore = useErrorStore();
    const accountStore = useAccountStore();

    watchEffect(() => {
      if (configStore.sidebar) {
        document.body.classList.remove("sidebar-hide");
        document.body.classList.add("sidebar-show");
      } else {
        document.body.classList.remove("sidebar-show");
        document.body.classList.add("sidebar-hide");
      }
    });
    watchEffect(() => {
      if (accountStore.me.edi.is_self_employee) {
        document.title = `${accountStore.me.last_name} ${accountStore.me.first_name} | ${configStore.systemName}`
      } else {
        document.title = `${accountStore.me.edi.company_name} | ${configStore.systemName}`
      }
    })
    return { configStore, errorStore };
  },
});
</script>
